"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class GLVerticalFilterNode {
  constructor(filters) {
    this.filters = filters;
  }

  initialize(gl) {
    this.filters.forEach(filter => filter.initialize(gl));
  }

  setViewSize(gl, width, height) {
    this.filters.forEach(filter => filter.setViewSize(gl, width, height));
  }

  setSize(gl, width, height) {
    this.filters.forEach(filter => filter.setSize(gl, width, height));
  }

  get outputTextureWidth() {
    let width = 0;

    for (const filter of this.filters) {
      width = Math.max(filter.outputTextureWidth, width);
    }

    return width;
  }

  get outputTextureHeight() {
    let height = 0;

    for (const filter of this.filters) {
      height = Math.max(filter.outputTextureHeight, height);
    }

    return height;
  }

  draw(gl, texture, flip) {
    for (var i = 0; i < this.filters.length; i++) {
      this.filters[i].draw(gl, texture, flip, i > 0);
    }
  }

}

exports.default = GLVerticalFilterNode;